import React from 'react';
import classnames from 'classnames';
import * as styles from './Rotator.module.styl';
import getImageURL from '../utils/getImageURL';

const colors = [
  'rgba(255,216,209, 0.6)',
  'rgba(46, 157, 212, 0.4)',
  'rgba(75, 215, 158, 0.3)',
  'rgba(239, 228, 87, 0.4)',
  'rgba(230, 31, 84, 0.3)',
  'rgba(158, 155, 247, 0.5)',
  'rgba(255,216,209, 0.6)',
  'rgba(46, 157, 212, 0.4)',
  'rgba(75, 215, 158, 0.3)',
  'rgba(239, 228, 87, 0.4)',
  'rgba(230, 31, 84, 0.3)',
  'rgba(158, 155, 247, 0.5)',
];

// function removeAlpha(color) {
//   let parts = color.split(',')
//   parts.pop()
//   return parts.join(',').replace('rbga', 'rgb') + ')'
//   return (
//     'rgb(' +
//     color
//       .replace(`rgba(`)
//       .split(',')
//       .slice(0, 3)
//       .join(', ') +
//     ')'
//   )
// }

export default class Rotator extends React.Component {
  constructor(props) {
    super();
    this.state = {
      active: props.options && props.options[0] && props.options[0].label,
    };
  }

  componentDidMount() {
    this.setupTimer();
  }

  componentWillUnmount() {
    clearInterval(this._timer);
  }

  setupTimer(x) {
    if (!x) x = this.props.interval || 3;
    if (this._timer) clearInterval(this._timer);

    this._timer = setInterval(() => {
      const active = this.props.options.find(
        (o) => o.label === this.state.active,
      );

      let i = this.props.options.indexOf(active);
      i += 1;
      if (!this.props.options[i]) i = 0;

      this.setState({
        active: this.props.options[i].label,
      });
    }, x * 1000);
  }

  renderContent(option, isActive, index) {
    if (typeof option.content === 'function') {
      return (
        <div
          key={index}
          style={{
            opacity: isActive ? 1 : 0,
            zIndex: isActive ? 100 : 0,
            transition: 'opacity .2s',
            position: 'absolute',
            top: 0,
            bottom: 0,
            height: '100%',
            width: '100%',
            backgroundSize: 'cover',
          }}
        >
          {option.content(isActive, index)}
        </div>
      );
    }
    return (
      <div
        key={index}
        style={{
          backgroundImage: isActive
            ? `url(${getImageURL(option.content)})`
            : 'none',
          opacity: isActive ? 1 : 0,
          transition: 'opacity .2s',
          position: 'absolute',
          top: 0,
          bottom: 0,
          height: '100%',
          width: '100%',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      >
        {option.description ? (
          <div className={styles.description}>
            <div style={{ display: 'inline-block' }}>{option.description}</div>
          </div>
        ) : null}
      </div>
    );
  }

  render() {
    const rotatorStyles = this.props.rotatorStyles || {};
    let i = this.props.options.find(
      (option) => option.label === this.state.active,
    );
    i = this.props.options.indexOf(i);
    const _i = i;
    return (
      <div
        className={this.props.wrapperClassName}
        style={
          this.props.colorize
            ? { backgroundColor: colors[i], transition: 'background 1s' }
            : null
        }
      >
        <div
          className={classnames(
            styles.rotator,
            this.props.reverse ? styles.reverse : null,
          )}
          style={rotatorStyles.wrapper}
        >
          {(this.props.header && (
            <div className={styles.mobileHeader}>{this.props.header}</div>
          )) ||
            null}
          <div
            className={classnames(
              styles.content,
              this.props.borderless ? styles.borderless : null,
            )}
          >
            {this.props.options.map((option, i) =>
              this.renderContent(option, option.label === this.state.active, i),
            )}
            <div
              style={{ paddingBottom: this.props.paddingPercentage || '56%' }}
            />
          </div>
          <div className={styles.options} style={rotatorStyles.options}>
            {(this.props.header && (
              <div className={styles.header}>{this.props.header}</div>
            )) ||
              null}
            {this.props.options.map((o, i) => (
              <div
                key={o.label}
                style={
                  i === _i && this.props.colorize
                    ? { boxShadow: `0 4px 15px -5px ${colors[i]}` }
                    : null
                }
                onClick={() =>
                  this.setState({ active: o.label }, () => {
                    this.setupTimer();
                  })
                }
                className={classnames(
                  styles.option,
                  o.label === this.state.active && styles.optionActive,
                  this.props.optionClassName,
                  o.label === this.state.active &&
                    this.props.optionActiveClassName,
                )}
              >
                {o.label}
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }
}
